export const MDYYYY_DATE_FORMAT = 'M/d/yyyy';

export const KEYMAP = {
  ENTER: 'Enter',
  SPACE: ' ',
  ESCAPE: 'Escape',
  TAB: 'Tab',
};

export const BASIC_ADMIN_PERMISSIONS = {
  persona_management_admin: ['Personas'],
  scim_integration_admin: ['SCIM'],
};

export const permissionDescriptions: Record<string, string> = {
  admin:
    'Full Administrator role, can add/view/remove users on TigerConnect, update user and org-wide settings, and assign User Permissions',
  customer:
    'Can only respond to messages that have an active conversation in their roster. They can not find broadcasts, roles, teams, or users.',
  feature_role_admin:
    "Can only update any Role's settings as well as create, manage, and delete any existing Roles",
  help_desk: "Help Desk role, can only view and update a User's settings only",
  patient_context_reporting: 'Can view Patient Context report',
  patient_data_audit_admin: 'Can only view the Patient Data report',
  patient_data_report_analytics: 'Allow the user to read the Patient Data report',
  patient_messaging_admin:
    'Can edit Patient Network Settings, add/edit/remove Patients and Contacts only',
  persona_management_admin:
    'Creates Permission Groups and view Persona Management & Persona Management Audit reports',
  provider_broadcast_list_admin:
    'Can only create/delete Provider Network Broadcasts as well as grant access to up to 30 users to search for and message a Broadcast',
  reporting: 'Access to Analytics section, including Trends and Transactions only',
  scim_integration_admin:
    'Allows the user to set up the integration of the SCIM connector as user provisioning',
  team_admin: 'Can create, manage, and delete any Teams within network only',
  tigertouchplus_reporting: 'Can only view the Patient Video report',
  virtual_waiting_room_admin:
    'Provides access to the Virtual Waiting Room section under Patient Settings',
};
